import React from 'react';
import { connect } from 'react-redux';

import CustomerInsightSearchOptions from './CustomerInsightSearchOptions';
import { loadCustomerInsightOrderFrequencySearch } from '../../../actions/restaurants/customerInsight/CustomerInsightAction';
import { loadRestaurantInsightHourlyStatisticSearch } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import OrderFrequencyChart from './OrderFrequencyChart';

class OrderFrequencyHourSearch extends React.Component {

    state = {
        fromDate: '',
        toDate: ''
    }

    componentDidMount() {
        const { restaurantId, customerId } = this.props;
        if(this.props.insightType ==='restaurant') {
            this.props.loadRestaurantInsightHourlyStatisticSearch(restaurantId, this.state.fromDate, this.state.toDate);
        } else {
            this.props.loadCustomerInsightOrderFrequencySearch(restaurantId, customerId, this.state.fromDate, this.state.toDate);
        }
    }

    takeSearchOptionState = searchOptionState => {
        if(this.props.insightType ==='restaurant') {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadRestaurantInsightHourlyStatisticSearch(restaurantId, searchOptionState.fromDate, searchOptionState.toDate);
        } else {
            this.setState({
                fromDate: searchOptionState.fromDate,
                toDate: searchOptionState.toDate
            })
    
            const { restaurantId, customerId } = this.props;
            this.props.loadCustomerInsightOrderFrequencySearch(restaurantId, customerId, searchOptionState.fromDate, searchOptionState.toDate);
        }
    }

    renderOrderFrequencyChart = () => {

        const { chartContainer } = styles;
        const orderFrequency = (this.props.insightType === 'restaurant' && this.props.restaurantInsightOrderFrequency) ? this.props.restaurantInsightOrderFrequency : this.props.customerInsightOrderFrequency

        return (
            <div style={chartContainer}>
                <OrderFrequencyChart
                    content={orderFrequency}
                    period="hour"
                    height={250}
                    width={1000}
                />
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <CustomerInsightSearchOptions type="OrderFrequency" takeSearchOptionState={this.takeSearchOptionState} />
                {this.renderOrderFrequencyChart()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        customerInsightOrderFrequency: state.customerInsightOrderFrequency,
        restaurantInsightOrderFrequency: state.restaurantInsight.orderHourlyFrequency,
        restaurant: state.restaurant
    }
};

export default connect(mapStateToProps, { 
    loadCustomerInsightOrderFrequencySearch,
    loadRestaurantInsightHourlyStatisticSearch })(OrderFrequencyHourSearch);

const styles = {
    chartContainer: {
        height: '360px',
        overflow: 'auto',
        marginTop: '50px',
        border: '1px solid gray',
        padding: '50px 20px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/customerInsightScreen/OrderFrequencyHourSearch.js